import type { InherentRiskItem } from '@/gen/inventory/v1/company_service_pb'

import { sortInherentRiskSource, sortRiskLevel } from '@/const/priority'

export const compareInherentRiskItems = (a: InherentRiskItem, b: InherentRiskItem): number =>
  sortInherentRiskSource(a.source, b.source) ||
  sortRiskLevel(a.severity, b.severity) ||
  a.displayName.localeCompare(b.displayName)

export const pickBestSingleSelectItem = (items: InherentRiskItem[]): InherentRiskItem | undefined =>
  items.sort(compareInherentRiskItems)[0]
